const DAY_MS = 24 * 60 * 60 * 1000;

// Compared as calendar days rather than as elapsed milliseconds, because a
// member reads "expires in 4 days" as four more days on the calendar, not as
// 96 hours from this moment. Rounding the difference between two local
// midnights also absorbs the 23-hour and 25-hour days a daylight-saving shift
// produces, which a plain division would round the wrong way.
const startOfDay = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

/**
 * How long a listing has left, in the words a card or a fact row renders.
 *
 * Returns an empty string for a missing or unparseable date, because every
 * caller renders the result directly and "Invalid Date" on a card is worse
 * than no line at all.
 *
 * @param {string | Date | null | undefined} expiresAt
 * @param {Date} [now] The point to count from. Defaults to the current time.
 * @returns {string}
 */
export function expiryWords(expiresAt, now = new Date()) {
    if (!expiresAt) {
        return '';
    }
    const end = new Date(expiresAt);
    if (Number.isNaN(end.getTime())) {
        return '';
    }
    const days = Math.round((startOfDay(end) - startOfDay(now)) / DAY_MS);
    if (days < 0) {
        return 'Expired';
    }
    if (days === 0) {
        return 'Expires today';
    }
    if (days === 1) {
        return 'Expires tomorrow';
    }
    return `Expires in ${days} days`;
}

export default expiryWords;
